/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { LogTestTermSecurityEventRequestDto } from '../models';
/**
 * TestTermSecurityEventApi - axios parameter creator
 * @export
 */
export const TestTermSecurityEventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Zapisuje zdarzenie anti-cheat (np. utrata fokusu okna, próba kopiowania) zaobserwowane po stronie klienta podczas wypełniania testu. Eventy są powiązane z aktywną egzekucją testu uczestnika dla wskazanego terminu. 
         * @summary Log an anti-cheat security event during a test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {LogTestTermSecurityEventRequestDto} logTestTermSecurityEventRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logTestTermSecurityEvent: async (certificationId: number, stageId: number, termId: number, logTestTermSecurityEventRequestDto: LogTestTermSecurityEventRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('logTestTermSecurityEvent', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('logTestTermSecurityEvent', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('logTestTermSecurityEvent', 'termId', termId)
            // verify required parameter 'logTestTermSecurityEventRequestDto' is not null or undefined
            assertParamExists('logTestTermSecurityEvent', 'logTestTermSecurityEventRequestDto', logTestTermSecurityEventRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms/{termId}/security-events`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"termId"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logTestTermSecurityEventRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestTermSecurityEventApi - functional programming interface
 * @export
 */
export const TestTermSecurityEventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestTermSecurityEventApiAxiosParamCreator(configuration)
    return {
        /**
         * Zapisuje zdarzenie anti-cheat (np. utrata fokusu okna, próba kopiowania) zaobserwowane po stronie klienta podczas wypełniania testu. Eventy są powiązane z aktywną egzekucją testu uczestnika dla wskazanego terminu. 
         * @summary Log an anti-cheat security event during a test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {LogTestTermSecurityEventRequestDto} logTestTermSecurityEventRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logTestTermSecurityEvent(certificationId: number, stageId: number, termId: number, logTestTermSecurityEventRequestDto: LogTestTermSecurityEventRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logTestTermSecurityEvent(certificationId, stageId, termId, logTestTermSecurityEventRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestTermSecurityEventApi.logTestTermSecurityEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestTermSecurityEventApi - factory interface
 * @export
 */
export const TestTermSecurityEventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestTermSecurityEventApiFp(configuration)
    return {
        /**
         * Zapisuje zdarzenie anti-cheat (np. utrata fokusu okna, próba kopiowania) zaobserwowane po stronie klienta podczas wypełniania testu. Eventy są powiązane z aktywną egzekucją testu uczestnika dla wskazanego terminu. 
         * @summary Log an anti-cheat security event during a test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {LogTestTermSecurityEventRequestDto} logTestTermSecurityEventRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logTestTermSecurityEvent(certificationId: number, stageId: number, termId: number, logTestTermSecurityEventRequestDto: LogTestTermSecurityEventRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.logTestTermSecurityEvent(certificationId, stageId, termId, logTestTermSecurityEventRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestTermSecurityEventApi - interface
 * @export
 * @interface TestTermSecurityEventApi
 */
export interface TestTermSecurityEventApiInterface {
    /**
     * Zapisuje zdarzenie anti-cheat (np. utrata fokusu okna, próba kopiowania) zaobserwowane po stronie klienta podczas wypełniania testu. Eventy są powiązane z aktywną egzekucją testu uczestnika dla wskazanego terminu. 
     * @summary Log an anti-cheat security event during a test term
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {LogTestTermSecurityEventRequestDto} logTestTermSecurityEventRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermSecurityEventApiInterface
     */
    logTestTermSecurityEvent(certificationId: number, stageId: number, termId: number, logTestTermSecurityEventRequestDto: LogTestTermSecurityEventRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * TestTermSecurityEventApi - object-oriented interface
 * @export
 * @class TestTermSecurityEventApi
 * @extends {BaseAPI}
 */
export class TestTermSecurityEventApi extends BaseAPI implements TestTermSecurityEventApiInterface {
    /**
     * Zapisuje zdarzenie anti-cheat (np. utrata fokusu okna, próba kopiowania) zaobserwowane po stronie klienta podczas wypełniania testu. Eventy są powiązane z aktywną egzekucją testu uczestnika dla wskazanego terminu. 
     * @summary Log an anti-cheat security event during a test term
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {LogTestTermSecurityEventRequestDto} logTestTermSecurityEventRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermSecurityEventApi
     */
    public logTestTermSecurityEvent(certificationId: number, stageId: number, termId: number, logTestTermSecurityEventRequestDto: LogTestTermSecurityEventRequestDto, options?: RawAxiosRequestConfig) {
        return TestTermSecurityEventApiFp(this.configuration).logTestTermSecurityEvent(certificationId, stageId, termId, logTestTermSecurityEventRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

